import { useMemo } from "react";
import { User } from "@coworker/apprestructured/src/shared/types/user";
import {
  FilterValue,
  StringArrayFilterValue,
} from "@coworker/apprestructured/src/shared/filters/types/filter";
import { StoreTeam } from "@coworker/types/lib/storeteam";

import { ROLE_MULTISELECT_ID } from "./filters/useRolesMultiSelectFilter";

const useFilteredUsers = (
  users: User[],
  teams: StoreTeam[],
  filters: FilterValue[],
  isLoadingUsers: boolean,
  teamId?: string,
  usersSearchQuery?: string
) =>
  useMemo(
    () =>
      users
        ?.filter((user) => {
          const conditionals: boolean[] = [];
          filters?.forEach((filterValue) => {
            switch (filterValue.filterId) {
              case ROLE_MULTISELECT_ID:
                conditionals.push(
                  (filterValue as StringArrayFilterValue)?.value?.includes(
                    user.roleId
                  )
                );
                break;
              default:
                break;
            }
          });
          if (usersSearchQuery) {
            conditionals.push(
              user.fullName
                .toLowerCase()
                .includes(usersSearchQuery.toLowerCase()) ||
                user.email
                  .toLowerCase()
                  .includes(usersSearchQuery.toLowerCase())
            );
          }
          return conditionals.every(Boolean);
        })
        .map((user) => {
          const userTeam = teams.find((team) => team.id === user.teamId);
          return {
            ...user,
            teamName: userTeam ? userTeam.name : "",
          };
        }),
    [filters, users, teams, teamId, isLoadingUsers, usersSearchQuery]
  );

export default useFilteredUsers;
